import { DollarsSchema } from '@mntn-dev/domain-types'

export const convertDollarsToCents = (val: number) => {
  return Math.round(DollarsSchema().parse(val * 100))
}
